const useFormCtx = require("./useFormCtx");
const upperFirst = require("mn-utils/upperFirst");
const isDefined = require("mn-utils/isDefined");
const isFunction = require("mn-utils/isFunction");
const get = require("mn-utils/get");
const noopHandle = require("mn-utils/noopHandle");
const map = require("mn-utils/map");
const {default: MenuItem} = require("@material-ui/core/MenuItem");
const React = require("react");

const mapSelectItems = ({items, propValue, propName, testId}) => {
  const _propValue = isDefined(propValue)
    ? (isFunction(propValue) ? propValue : ((item) => get(item, propValue)))
    : noopHandle;
  const _propName = isDefined(propName) || isDefined(propValue)
    ? (
      isFunction(propName)
        ? propName
        : ((item) => upperFirst('' + get(item, (propName || propValue))))
    )
    : noopHandle;

  return map(items, (item) => {
    const value = _propValue(item);
    const disabled = !!(item && item.disabled);

    if (item.separator) {
      return (
        <MenuItem
          key={value}
          value={value}
          disabled
        >
          <div className="w">
            <div className="h1 bg6 mh-10"/>
          </div>
        </MenuItem>
      );
    }
    return (
      <MenuItem
        key={value}
        value={value}
        disabled={disabled}
        data-testid={testId ? `${testId}--${value}` : ''}
      >{_propName(item)}</MenuItem>
    );
  });
}

module.exports = (Component) => (
  {
    className,
    items,
    propValue,
    propName,
    testId,
    ...props
  }
) => {
  const {
    id,
    label,
    name,
    value,
    error,
    showError,
    isRequired,
    onChange,
    disabled
  } = useFormCtx(props);

  const itemsDisplay = mapSelectItems({
    items,
    propValue,
    propName,
    testId
  });

  return (
    <Component
      className={className}
      labelProps={{
        id,
        label,
        isRequired
      }}
      selectProps={{
        id,
        value,
        name,
        itemsDisplay,
        onChange,
        disabled,
        testId
      }}
      errorProps={{
        showError,
        error
      }}
    />
  );
}
